/* Bundle pack tiers:
 *   1 pack  -> FSMV593230BN (10% off)
 *   2 packs -> RNB14JHA5K7T (15% off)
 *   3+      -> 9MY3XC7MVZFP (20% off)
 * Pack quantity is the combined quantity of bundle-builder products already
 * in the cart. Creatine and other products are ignored. Customer discount
 * codes that are not one of these tiers are left in place.
 */
(function () {
  if (window.FortifiedBundleTier) return;

  var TIER_CODES = ['FSMV593230BN', 'RNB14JHA5K7T', '9MY3XC7MVZFP'];
  var STORAGE_KEY = 'ftd-bundle-pack-product-ids';
  var chain = Promise.resolve();
  var qtyTimer = 0;

  function getTierDiscountCode(totalQuantity) {
    totalQuantity = Number(totalQuantity) || 0;
    if (totalQuantity === 1) return 'FSMV593230BN';
    if (totalQuantity === 2) return 'RNB14JHA5K7T';
    if (totalQuantity >= 3) return '9MY3XC7MVZFP';
    return '';
  }

  function root() {
    var value = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return value.replace(/\/?$/, '/');
  }

  function cartUrl(path) {
    var routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : null;
    if (path === 'update' && routes && routes.cart_update_url) return routes.cart_update_url;
    if (path === 'cart' && routes && routes.cart_url) return routes.cart_url + '.js';
    return root() + (path === 'update' ? 'cart/update.js' : 'cart.js');
  }

  function addId(ids, id) {
    if (id == null || id === '') return;
    ids[String(id)] = true;
  }

  function packProductIds() {
    var ids = Object.create(null);
    var config = window.__bundleTierConfig || {};
    (config.productIds || []).forEach(function (id) { addId(ids, id); });
    document.querySelectorAll('.bundle-builder [data-flavor][data-product-id]').forEach(function (node) {
      addId(ids, node.getAttribute('data-product-id'));
    });
    try {
      JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]').forEach(function (id) { addId(ids, id); });
      var known = Object.keys(ids);
      if (known.length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(known));
    } catch (error) { /* storage unavailable */ }
    return ids;
  }

  function isTier(code) {
    return TIER_CODES.indexOf(String(code || '').trim().toUpperCase()) !== -1;
  }

  function isPack(line, ids) {
    if (!line) return false;
    var props = line.properties || {};
    if (String(props._bundle_pack || '') === '1') return true;
    return !!ids[String(line.product_id)];
  }

  function packQuantity(cart) {
    var ids = packProductIds();
    return ((cart && cart.items) || []).reduce(function (total, line) {
      var quantity = Number(line.quantity) || 0;
      if (quantity <= 0 || !isPack(line, ids)) return total;
      return total + quantity;
    }, 0);
  }

  function currentCodes(cart) {
    var codes = [];
    var entries = cart && cart.discount_codes;
    if (!Array.isArray(entries)) return codes;
    entries.forEach(function (entry) {
      var code = typeof entry === 'string' ? entry : entry && entry.code;
      code = String(code || '').trim();
      if (code) codes.push(code);
    });
    return codes;
  }

  function sameCodes(left, right) {
    if (left.length !== right.length) return false;
    var a = left.map(function (code) { return code.toUpperCase(); }).sort();
    var b = right.map(function (code) { return code.toUpperCase(); }).sort();
    return a.every(function (code, index) { return code === b[index]; });
  }

  function desiredCodes(cart) {
    var codes = currentCodes(cart).filter(function (code) { return !isTier(code); });
    var tier = getTierDiscountCode(packQuantity(cart));
    if (tier) codes.push(tier);
    return codes;
  }

  function tierApplicable(cart, tier) {
    if (!tier) {
      return !currentCodes(cart).some(isTier);
    }
    return (cart.discount_codes || []).some(function (entry) {
      var code = typeof entry === 'string' ? entry : entry && entry.code;
      return String(code || '').toUpperCase() === tier.toUpperCase() && entry.applicable !== false;
    });
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (node) {
      var id = node.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function readCart() {
    return fetch(cartUrl('cart'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok || !cart || !Array.isArray(cart.items)) {
          throw new Error((cart && (cart.description || cart.message)) || 'Could not read the cart.');
        }
        return cart;
      });
    });
  }

  function writeDiscount(codes) {
    var ids = sectionIds();
    var payload = { discount: codes.join(',') };
    if (ids.length) {
      payload.sections = ids.join(',');
      payload.sections_url = window.location.pathname;
    }
    return fetch(cartUrl('update'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok || !cart || !Array.isArray(cart.items)) {
          throw new Error((cart && (cart.description || cart.message)) || 'Could not update the bundle discount.');
        }
        return cart;
      });
    });
  }

  function fallbackRefresh(cart) {
    var sections = cart && cart.sections;
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      var current = document.getElementById('shopify-section-' + id);
      if (!html || !current) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById('shopify-section-' + id);
      current.innerHTML = fresh ? fresh.innerHTML : html;
    });
  }

  function refreshCartUi(cart) {
    var sections = cart && cart.sections;
    return import('@shopify/events').then(function (mod) {
      var Ctor = mod && mod.CartDiscountUpdateEvent;
      if (!Ctor || typeof Ctor.createPromise !== 'function') {
        fallbackRefresh(cart);
        return;
      }
      var deferred = Ctor.createPromise();
      document.dispatchEvent(new Ctor({
        discountCodes: currentCodes(cart).map(function (code) { return { code: code }; }),
        promise: deferred.promise
      }));
      var summary = typeof Ctor.createCartFromAjaxResponse === 'function'
        ? Ctor.createCartFromAjaxResponse(cart)
        : cart;
      deferred.resolve({
        cart: summary,
        detail: {
          sections: sections,
          items: cart.items,
          itemCount: cart.item_count || 0,
          source: 'bundle-tier-discount',
          didError: false
        }
      });
    }).catch(function () {
      fallbackRefresh(cart);
    });
  }

  function apply(seedCart, refresh) {
    var read = seedCart && Array.isArray(seedCart.items) ? Promise.resolve(seedCart) : readCart();
    return read.then(function (cart) {
      if (!Object.keys(packProductIds()).length && !((cart.items || []).some(function (line) {
        return String((line.properties || {})._bundle_pack || '') === '1';
      }))) {
        return cart;
      }
      var next = desiredCodes(cart);
      if (sameCodes(currentCodes(cart), next)) return cart;
      return writeDiscount(next).then(function (updated) {
        var tier = getTierDiscountCode(packQuantity(updated));
        var extras = next.filter(function (code) { return !isTier(code); });
        if (tier && extras.length && !tierApplicable(updated, tier)) {
          return writeDiscount([tier]);
        }
        return updated;
      }).then(function (updated) {
        if (!refresh) return updated;
        return refreshCartUi(updated).then(function () { return updated; });
      });
    });
  }

  function sync(seedCart, options) {
    var refresh = !options || options.refresh !== false;
    var run = chain.then(function () { return apply(seedCart, refresh); });
    chain = run.then(function (cart) { return cart; }, function () { return null; });
    return run;
  }

  function schedule() {
    window.setTimeout(function () { sync().catch(function () {}); }, 0);
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(schedule, schedule);
      return;
    }
    schedule();
  });

  document.addEventListener('cart:refresh', schedule);

  document.addEventListener('quantity-selector:update', function (event) {
    if (!event.detail || !event.detail.cartLine) return;
    window.clearTimeout(qtyTimer);
    qtyTimer = window.setTimeout(function () { sync().catch(function () {}); }, 800);
  });

  if (!window.__bundleTierFetch && typeof window.fetch === 'function') {
    window.__bundleTierFetch = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var response = nativeFetch(input, init);
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (error) {
        url = '';
      }
      if (/\/cart\/change(?:\.js)?(?:\?|$)/.test(url)) {
        response.then(function (result) {
          if (result && result.ok) schedule();
        }, function () {});
      }
      return response;
    };
  }

  window.setTimeout(function () { sync().catch(function () {}); }, 800);

  window.getTierDiscountCode = getTierDiscountCode;
  window.FortifiedBundleTier = {
    getTierDiscountCode: getTierDiscountCode,
    packQuantity: packQuantity,
    sync: sync
  };
})();
